/**
 * Returns a safe same-origin relative path for post-auth redirects.
 * Rejects open redirects (absolute URLs, protocol-relative paths, backslashes).
 */
export function safeNext(raw: string | null): string {
  if (raw == null || raw === '') {
    return '/';
  }
  if (!raw.startsWith('/') || raw.startsWith('//')) {
    return '/';
  }
  if (raw.includes('://') || raw.includes('\\')) {
    return '/';
  }
  return raw;
}
